import { useNavigate } from "react-router-dom";
import styles from "./menus/NavMenu.module.css";

const NavOption = ({
  classOverride,
  displayText,
  navigateTo,
  ACTIONS,
  dispatch,
  state,
  closeMenus,
}) => {
  const navigate = useNavigate();

  const onClickHandler = (event) => {
    event.preventDefault();
    navigate(navigateTo, {
      replace: true,
    });
    closeMenus();
    if (state.mobileMenuOpen) {
      dispatch({ type: ACTIONS.MOBILE_MENU_TOGGLE });
    }
  };

  return (
    <li>
      <button
        className={classOverride ? classOverride : styles.menuOptionButton}
        onClick={onClickHandler}
      >
        {displayText}
      </button>
    </li>
  );
};

export default NavOption;
